import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";
import { View3d } from "../View3d.js";
import { VOMarker } from "../../model/Structure.js";

export class ControlMinimap extends BaseControl {
    private _minimapCurve: HTMLCanvasElement;
    private _minimapCtx: CanvasRenderingContext2D;
    private _view3d: View3d;
    private _items: ControlMinimapItem[] = [];
    private element: HTMLElement;

    constructor(pano: Pano, view3d: View3d) {
        super(pano);

        this.element = document.createElement("div");
        this.element.classList.add("minimap");
        this.element.innerHTML = `
        <canvas class="minimap-fov" width="60" height="60"></canvas>
        <div class="minimap-markers"></div>
        `;
        this.pano.addControl(this.element, ControlPosition.OVERLAY);
        this._minimapCurve = this.element.querySelector(".minimap-fov");


        this._view3d = view3d;
        this._minimapCtx = this._minimapCurve.getContext("2d");
        this.updateFov();

        this.pano.onChangeCameraFov.add(() => this.updateFov());
        this.pano.onChangeCameraDirection.add(() => this.updateDirection());
        this.pano.onChangeVideo.add((video) => {
            this.updateMarkers();
        });

        this.pano.onChangeMarkerPosition.add(() => {
            this.updateMarkers();
        });
    }

    private updateMarkers(): void {
        const markers = this.element.querySelector(".minimap-markers");
        const video = this.pano.current;

        for (var item of this._items) {
            item.dispose();
        }
        this._items = [];
        markers.innerHTML = "";

        const visible = video && video.markers && video.markers.length > 0;
        this.element.classList.toggle("hidden", !visible);

        if (!visible) {
            return;
        }

        for (var marker of video.markers) {
            var item = new ControlMinimapItem(marker);
            markers.appendChild(item.element);
            this._items.push(item);
        }
    }

    private updateFov(): void {
        var can = this._minimapCurve;
        var ctx = this._minimapCtx;
        ctx.clearRect(0, 0, can.width, can.height);

        var radius = 26;
        var fov = this._view3d.camera.fov * Math.PI / 180;
        var cx = can.width * 0.5;
        var cy = can.height * 0.5;

        ctx.fillStyle = "rgba(255, 255, 255, 1)";
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, fov);
        ctx.lineTo(cx, cy);
        ctx.fill();

        this.updateDirection();
    }

    private updateDirection(): void {
        var angle = -this._view3d.orbit.lngCurrent;
        angle -= this._view3d.camera.fov * 0.5;
        angle -= 90;
        this._minimapCurve.style.transform = "rotate(" + angle + "deg)";
    }
}

class ControlMinimapItem {
    public element: HTMLElement;
    private _marker: VOMarker;

    constructor(marker: VOMarker) {
        var radius = 20;
        var centerX = 30;
        var centerY = 30;

        this._marker = marker;
        this._marker.delegates.push(this);

        this.element = document.createElement("div");
        this.element.classList.add("minimap-markers-item");

        var x = centerX;
        var y = centerY;
        var angle = (marker.marker_x * 360 + 90) * Math.PI / 180;
        x += Math.cos(angle) * radius;
        y += Math.sin(angle) * radius;
        this.element.style.transform = "translate(" + x + "px, " + y + "px) translate(-50%, -50%)";
    }

    public get visible(): boolean {
        return !this.element.classList.contains("hidden");
    }

    public set visible(visible: boolean) {
        this.element.classList.toggle("hidden", !visible);
    }

    public dispose(): void {
        this._marker.delegates.splice(this._marker.delegates.indexOf(this), 1);
        this.element.remove();
        this.element = null;
        this._marker = null;
    }
}